import styled from "styled-components";

export const EditorContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 0;
  width: 100%;
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  padding: 6px 8px;
  background-color: #f8fafc;
  border: 1px solid #d1d5db;
  border-bottom: none;
  border-radius: 8px 8px 0 0;
  flex-wrap: wrap;
`;

export const ToolbarButton = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  padding: 0;
  background-color: ${({ $active }) => ($active ? "#e0e7eb" : "transparent")};
  border: 1px solid ${({ $active }) => ($active ? "#d1d5db" : "transparent")};
  border-radius: 5px;
  cursor: pointer;
  color: ${({ $active }) => ($active ? "#111827" : "#374151")};
  font-size: 0.85rem;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  transition: all 0.15s ease;
  flex-shrink: 0;

  img {
    width: 16px;
    height: 16px;
    display: block;
  }

  &:hover {
    background-color: ${({ $active }) => ($active ? "#d1d5db" : "#e5e7eb")};
    border-color: #d1d5db;
    color: #111827;
  }

  &:active {
    background-color: #d1d5db;
    transform: scale(0.96);
  }
`;

export const ToolbarDivider = styled.span`
  display: inline-block;
  width: 1px;
  height: 20px;
  background-color: #d1d5db;
  margin: 0 4px;
  flex-shrink: 0;
`;

export const CreateVariableButton = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 4px 10px;
  background-color: #128c7e;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  font-size: 0.8rem;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  transition: all 0.15s ease;
  white-space: nowrap;
  flex-shrink: 0;

  &:hover {
    background-color: #0d6b5f;
    transform: scale(1.02);
  }

  &:active {
    background-color: #0a5a51;
    transform: scale(0.98);
  }
`;

export const EditorArea = styled.div`
  width: 100%;
  min-height: 120px;
  max-height: 300px;
  overflow-y: auto;
  padding: 12px;
  box-sizing: border-box;
  font-family: "Inter", sans-serif;
  font-size: 0.95rem;
  color: #1f2937;
  line-height: 1.6;
  border: 1px solid ${({ $error }) => ($error ? "#ef4444" : "#d1d5db")};
  border-radius: 0 0 8px 8px;
  outline: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
  background-color: #ffffff;
  word-wrap: break-word;
  word-break: break-word;

  &:focus {
    border-color: ${({ $error }) => ($error ? "#ef4444" : "#2c5f4e")};
    box-shadow: 0 0 0 3px
      ${({ $error }) =>
        $error ? "rgba(239, 68, 68, 0.1)" : "rgba(44, 95, 78, 0.1)"};
  }

  &:empty::before {
    content: attr(data-placeholder);
    color: #9ca3af;
    pointer-events: none;
  }

  p {
    margin: 0;
    padding: 0;
    min-height: 1.4em;
  }

  .variable-chip {
    display: inline-flex;
    align-items: center;
    padding: 2px 8px;
    margin: 0 2px;
    background-color: #128c7e;
    color: white;
    border-radius: 4px;
    font-size: 0.813rem;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s ease;
    user-select: none;
    line-height: 1.4;
    vertical-align: middle;

    &:hover {
      background-color: #0d6b5f;
      transform: scale(1.05);
    }
  }
`;

export const CharCounter = styled.div`
  margin-top: 4px;
  text-align: right;
  font-size: 0.78rem;
  font-family: "Inter", sans-serif;
  color: ${({ $overLimit }) => ($overLimit ? "#ef4444" : "#9ca3af")};
  font-weight: ${({ $overLimit }) => ($overLimit ? "600" : "400")};
  transition: color 0.2s ease;
`;

export const ErrorMessage = styled.span`
  display: block;
  margin-top: 4px;
  font-size: 0.8rem;
  color: #991b1b;
  font-family: "Inter", sans-serif;
`;

export const ChipTooltip = styled.div`
  position: fixed;
  z-index: 9999;
  top: ${({ $top }) => $top}px;
  left: ${({ $left }) => $left}px;
  transform: translateX(-50%);
  background-color: #1f2937;
  color: #f9fafb;
  font-size: 0.72rem;
  font-weight: 500;
  font-family: "Inter", sans-serif;
  padding: 5px 12px;
  border-radius: 6px;
  white-space: nowrap;
  pointer-events: none;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  letter-spacing: 0.01em;
  animation: tooltipFadeIn 0.15s ease forwards;

  &::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    transform: translateX(-50%);
    border: 5px solid transparent;
    border-top-color: #1f2937;
  }

  @keyframes tooltipFadeIn {
    from {
      opacity: 0;
      transform: translateX(-50%) translateY(3px);
    }
    to {
      opacity: 1;
      transform: translateX(-50%) translateY(0);
    }
  }
`;
